import { customElement } from "lit/decorators.js";
import { Paragraph } from "../paragraph";

@customElement("eko-modal-subtitle")
class ModalSubtitle extends Paragraph {
  constructor() {
    super();

    this.theme = "weak";
    this.size = "md";
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-modal-subtitle": ModalSubtitle;
  }
}

export default ModalSubtitle;
